import { TableColumn, TableOrder } from "..";

export function getDefaultSortOrder<TRecord>(columns: TableColumn<TRecord>[]): TableOrder {
  if (columns.some((column) => column.field === "to_date")) return "desc";
  return "asc";
}
